import { $ } from '../../platform/dom';
import { EVOLUTIONS } from '../../data/evolutions';
import { UNIONS } from '../../data/unions';
import { MECH_UPGRADES, mechUpById, mechUpMax, mechUpName } from '../../data/mech-upgrades';
import { PASSIVES, passiveById, passiveMax } from '../../data/passives';
import {
  CRAFT_GATE_W, CRAFT_MAX, MAX_LEVEL, craftById, craftGateP, passives, weaponById,
  weaponLevel, weapons
} from '../../sim/loadout';
import { mechUpLevel } from '../../sim/mech-upgrades';
import { protocolIds } from '../../sim/protocols';
import { protocolById } from '../../data/protocols';
import { STATE } from '../../sim/fx';
import { P } from '../../world/player';
import { RUN_LEN } from '../../sim/stage-flow';
import { iconFor } from '../../data/icons';
import { registerScreen } from './router';
/* ============================================================
   暫停 ＝ 作戰狀態面板（2026-08-05，使用者拍板）
   ============================================================

   在這之前按 P 只會丟一個「暫停」兩個字的橫幅，戰場連暗都不暗 ——
   實看截圖上那個狀態看起來像當機。

   為什麼不是三顆按鈕就好：倖存者類的玩家在暫停時**最常做的事是看自己的
   build**，而這個遊戲還多一件事要看 —— 交接文件指出一場只拿得到 3 個質變，
   而玩家根本不知道自己在湊什麼（`.claude/notes/p2-timeline.md`）。
   所以右半邊是【質變進度】：每一條進化／融合差什麼、差幾級，直接列出來。
   這一頁不改任何數值，它只是把已經存在的資訊講清楚。 */

var CRAFT_ROWS = 6;   // 最多列幾條質變進度（差最少的排前面）

function pips(lv: number, max: number) {
  var out = '';
  for (var i = 0; i < max; i++) out += '<i class="' + (i < lv ? 'on' : '') + '"></i>';
  return '<span class="ppips">' + out + '</span>';
}

function row(icon: string, name: string, lv: number, max: number) {
  var full = lv >= max;
  return '<div class="prow' + (full ? ' full' : '') + '">' +
    (icon ? '<img src="' + icon + '" alt="">' : '<i class="noimg"></i>') +
    '<span>' + name + '</span>' + pips(lv, max) +
    '<b>' + lv + (full ? '' : '/' + max) + '</b></div>';
}

/** 左欄：目前的整組 build。 */
function buildHtml() {
  var out = '';
  if (weapons.length) {
    out += '<div class="psec"><span class="eyebrow">武裝</span>';
    weapons.forEach(function (w) {
      var d: any = weaponById(w.id);
      /* 質變的上限是 `CRAFT_MAX`（3）不是 `MAX_LEVEL`（5）——
         一律比 5 的話練滿的質變會顯示成 3/5，看起來像還沒練完。 */
      out += row(iconFor(w.id), d ? d.n : w.id, w.lv, craftById(w.id) ? CRAFT_MAX : MAX_LEVEL);
    });
    out += '</div>';
  }
  if (passives.length) {
    out += '<div class="psec"><span class="eyebrow">被動</span>';
    passives.forEach(function (p) {
      var d: any = passiveById(p.id);
      out += row(iconFor(p.id) || (d && d.axes ? iconFor('ax-' + d.axes[0]) : ''),
        d ? d.n : p.id, p.lv, passiveMax(d));
    });
    out += '</div>';
  }
  var mw = MECH_UPGRADES.filter(function (u) { return mechUpLevel(u.id) > 0; });
  if (mw.length) {
    out += '<div class="psec"><span class="eyebrow">機體強化</span>';
    mw.forEach(function (u) {
      out += row(iconFor(u.ico), mechUpName(u), mechUpLevel(u.id), mechUpMax(u));
    });
    out += '</div>';
  }
  var pr = protocolIds();
  if (pr.length) {
    out += '<div class="psec"><span class="eyebrow">破格協定</span>';
    pr.forEach(function (id) {
      var d: any = protocolById(id);
      out += '<div class="prow prot"><img src="' + (iconFor(id) || '') + '" alt="">' +
        '<span>' + (d ? d.n : id) + '</span><b>—</b></div>';
    });
    out += '</div>';
  }
  return out || '<p class="pempty">還沒有任何強化。</p>';
}

/** 一條質變還差什麼。回 `null` 代表玩家連來源都還沒拿到（不用列）。 */
function craftGap(c: any) {
  var need: { n: string, lv: number, max: number }[] = [];
  var got = 0, tot = 0;
  if (c.evo) {
    var w: any = weaponById(c.evo.from), k: any = passiveById(c.evo.needs);
    var wl = weaponLevel(c.evo.from), kl = 0;
    for (var i = 0; i < passives.length; i++) if (passives[i].id === c.evo.needs) kl = passives[i].lv;
    if (!wl && !kl) return null;
    /* 這裡要的是**門檻**不是等級上限（2026-08-06 拆成兩個常數）。
       而且 `lv` 可能超過門檻（門檻 3、武裝練到 5），所以夾一次再算百分比，
       不夾的話進度條會超過 100%。 */
    var km = craftGateP(k);
    need.push({ n: w ? w.n : c.evo.from, lv: Math.min(wl, CRAFT_GATE_W), max: CRAFT_GATE_W });
    need.push({ n: k ? k.n : c.evo.needs, lv: Math.min(kl, km), max: km });
    got = Math.min(wl, CRAFT_GATE_W) + Math.min(kl, km); tot = CRAFT_GATE_W + km;
  } else {
    var a: any = weaponById(c.union.a), b: any = weaponById(c.union.b);
    var al = weaponLevel(c.union.a), bl = weaponLevel(c.union.b);
    if (!al && !bl) return null;
    need.push({ n: a ? a.n : c.union.a, lv: Math.min(al, CRAFT_GATE_W), max: CRAFT_GATE_W });
    need.push({ n: b ? b.n : c.union.b, lv: Math.min(bl, CRAFT_GATE_W), max: CRAFT_GATE_W });
    got = Math.min(al, CRAFT_GATE_W) + Math.min(bl, CRAFT_GATE_W); tot = CRAFT_GATE_W * 2;
  }
  /* 已經做出來的（合成品本身在持有清單裡）＝完成，排最前面當獎狀。 */
  var done = weaponLevel(c.id) > 0;
  return { c: c, need: need, pct: got / tot, done: done };
}

/** 右欄下半：質變進度。**差最少的排前面** —— 玩家要的是「下一個能拿到的是哪個」。 */
function craftHtml() {
  var all: any[] = [];
  EVOLUTIONS.concat(UNIONS as any).forEach(function (c: any) {
    var g = craftGap(c);
    if (g) all.push(g);
  });
  all.sort(function (x, y) { return (y.done ? 2 : 0) - (x.done ? 2 : 0) || y.pct - x.pct; });
  if (!all.length) {
    return '<p class="pempty">先把一把武裝練起來 —— 質變的前置是「武裝滿級 + 鑰匙被動滿級」。</p>';
  }
  return all.slice(0, CRAFT_ROWS).map(function (g) {
    var bars = g.need.map(function (n: any) {
      return '<div class="pneed' + (n.lv >= n.max ? ' ok' : '') + '">' +
        '<span>' + n.n + '</span><b>' + n.lv + '/' + n.max + '</b></div>';
    }).join('');
    return '<div class="pcraft' + (g.done ? ' done' : '') + '">' +
      '<div class="pchead"><span>' + g.c.n + '</span>' +
      '<b>' + (g.done ? '已取得' : Math.round(g.pct * 100) + '%') + '</b></div>' +
      '<div class="pbar"><div style="width:' + Math.round(g.pct * 100) + '%"></div></div>' +
      '<div class="pneeds">' + bars + '</div></div>';
  }).join('');
}

function mmss(sec: number) {
  var m = Math.floor(sec / 60), s = Math.floor(sec % 60);
  return m + ':' + (s < 10 ? '0' : '') + s;
}

function statHtml() {
  var left = Math.max(0, RUN_LEN - STATE.t);
  return [
    ['已作戰', mmss(STATE.t)], ['剩餘', mmss(left)],
    ['等級', String(P.lv)], ['擊墜', String(P.kills)],
    ['結構', Math.ceil(P.hp) + ' / ' + P.hpMax], ['緊急重啟', String(P.revives)]
  ].map(function (r) {
    return '<div class="pstat"><span>' + r[0] + '</span><b>' + r[1] + '</b></div>';
  }).join('');
}

var registered = false;
/* 三個動作由 `ui/hud.ts` 在第一次暫停時注入。
   **不要在這個檔 import hud** —— hud 已經 import 了 codex，而 codex 關閉時
   要叫得到這裡（對局中按 C 開圖鑑會順便暫停），繞回去就是循環相依。 */
var H = { resume: function () {}, settings: function () {}, quit: function () {} };
export function setPauseHandlers(h: { resume: () => void, settings: () => void, quit: () => void }) { H = h; }

export function drawPause() {
  var l = $('pauseBuild'); if (l) l.innerHTML = buildHtml();
  var st = $('pauseStats'); if (st) st.innerHTML = statHtml();
  var cf = $('pauseCraft'); if (cf) cf.innerHTML = craftHtml();
}

/** 開暫停面板。**不自己動 `STATE.paused`** —— 那是 `ui/hud.ts` 的 `togglePause`
    的責任，兩個地方都寫的話一定會有路徑漏掉其中一個（這個檔案的舊註解記過）。 */
export function openPause() {
  drawPause();
  if (!registered) {
    registered = true;
    registerScreen({ id: 'screenPause', onEsc: function () { H.resume(); } });
    var r = $('btnResume'); if (r) r.addEventListener('click', function () { H.resume(); });
    var s = $('btnPauseSet'); if (s) s.addEventListener('click', function () { H.settings(); });
    var q = $('btnQuit'); if (q) q.addEventListener('click', function () { H.quit(); });
  }
  var el: any = $('screenPause'); if (el) el.classList.add('show');
}

export function closePause() {
  var el: any = $('screenPause'); if (el) el.classList.remove('show');
}
